import React, { useState, useMemo } from 'react'
import { useVehicles } from '../../../context/VehicleContext'
import FleetSummaryCards from './FleetSummaryCards'
import FleetOemReport from './FleetOemReport'
// import CommIgnOffReport from './CommIgnOffReport'
import CyberButton from './CyberButton'
// import InlineLoader from '../../helpers/hoc/loader/InlineLoader'

const COMM_KEYS = new Set(['Communicating', 'Communicating but Vehicle Off / No Network'])
const NON_COMM_KEY = 'Non-Communicating'

// const TABS = [
//   { id: 'fleet-status', label: 'Fleet Status Report' },
//   { id: 'comm-ign-off', label: 'Communicating · Ignition OFF' },
// ]

const SAMenu = () => {
  const { vehicles, loading, error, lastUpdated, countdown, load } = useVehicles()
  // const [activeTab, setActiveTab] = useState('fleet-status')
  const [cityFilter,        setCityFilter]        = useState('All cities')
  const [hubFilter,         setHubFilter]         = useState('All hubs')
  const [vehicleTypeFilter, setVehicleTypeFilter] = useState('All')
  const [statusFilter,      setStatusFilter]      = useState('All')

  const cityOptions = useMemo(() => {
    const cities = Array.from(new Set(vehicles.map(v => v.mg?.city).filter(Boolean))).sort()
    return ['All cities', ...cities]
  }, [vehicles])

  const vehicleTypeOptions = useMemo(() => {
    const types = Array.from(new Set(vehicles.map(v => v.mg?.vehicle_type).filter(Boolean))).sort()
    return ['All', ...types]
  }, [vehicles])

  const hubOptions = useMemo(() => {
    const source = cityFilter !== 'All cities'
      ? vehicles.filter(v => v.mg?.city === cityFilter)
      : vehicles
    const hubs = Array.from(new Set(source.map(v => v.mg?.depot_name).filter(Boolean))).sort()
    return ['All hubs', ...hubs]
  }, [vehicles, cityFilter])

  const handleCityChange = (city) => {
    setCityFilter(city)
    setHubFilter('All hubs')
  }

  // city+hub+vehicleType filtered base — used by CommIgnOffReport (independent of status filter)
  const commIgnBase = useMemo(() => {
    let result = vehicles
    if (cityFilter !== 'All cities')  result = result.filter(v => v.mg?.city === cityFilter)
    if (hubFilter !== 'All hubs')     result = result.filter(v => v.mg?.depot_name === hubFilter)
    if (vehicleTypeFilter !== 'All')  result = result.filter(v => v.mg?.vehicle_type === vehicleTypeFilter)
    return result
  }, [vehicles, cityFilter, hubFilter, vehicleTypeFilter])

  const filtered = useMemo(() => {
    let result = commIgnBase
    if (statusFilter === 'Communicating')     result = result.filter(v => COMM_KEYS.has(v.status))
    if (statusFilter === 'Non-Communicating') result = result.filter(v => v.status === NON_COMM_KEY)
    if (statusFilter === 'No API')            result = result.filter(v => v.status === 'No API')
    if (statusFilter === '>12h Ignition Off') result = result.filter(v => v.status === 'More than 12 hours ignition off')
    return result
  }, [commIgnBase, statusFilter])

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: 'rgba(255,255,255,0.6)', fontSize: 15 }}>
        {/* <InlineLoader /> */}
        Loading fleet data…
      </div>
    )
  }

  if (error) {
    return (
      <div style={{ padding: 24, color: '#fca5a5', fontSize: 14 }}>
        {error}
        <CyberButton onClick={load} style={{ marginLeft: 12 }}>Retry</CyberButton>
      </div>
    )
  }

  return (
    <div style={{ padding: '20px 24px', color: '#fff', minHeight: '100%' }}>

      {/* Header bar */}
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: '#fff', letterSpacing: 0.3 }}>Fleet Dashboard</h1>
        {lastUpdated && (
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.40)', marginTop: 3 }}>
            Last updated {lastUpdated.toLocaleTimeString()} · refresh in {countdown}s
          </div>
        )}
      </div>

      {/* Summary cards */}
      <FleetSummaryCards vehicles={filtered} />

      {/* Tab navigation — uncomment when CommIgnOffReport is ready to ship
      <div style={{ display: 'flex', gap: 0, marginTop: 24, borderBottom: '2px solid #424666' }}>
        {TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              padding: '9px 20px',
              background: 'none',
              border: 'none',
              borderBottom: activeTab === tab.id ? '2px solid #7c3aed' : '2px solid transparent',
              marginBottom: -2,
              cursor: 'pointer',
              fontSize: 13,
              fontWeight: 700,
              color: activeTab === tab.id ? '#c4b5fd' : 'rgba(255,255,255,0.40)',
              letterSpacing: 0.2,
              transition: 'color 0.15s',
              outline: 'none',
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>
      */}

      {/* Fleet Status Report */}
      <FleetOemReport
        vehicles={filtered}
        cityFilter={cityFilter} setCityFilter={handleCityChange} cityOptions={cityOptions}
        hubFilter={hubFilter}   setHubFilter={setHubFilter}       hubOptions={hubOptions}
        vehicleTypeFilter={vehicleTypeFilter} setVehicleTypeFilter={setVehicleTypeFilter} vehicleTypeOptions={vehicleTypeOptions}
        statusFilter={statusFilter} setStatusFilter={setStatusFilter}
      />

      {/* Communicating · Ignition OFF report — uncomment when ready to ship
      {activeTab === 'comm-ign-off' && (
        <CommIgnOffReport
          vehicles={commIgnBase}
          cityFilter={cityFilter} setCityFilter={handleCityChange} cityOptions={cityOptions}
          hubFilter={hubFilter}   setHubFilter={setHubFilter}       hubOptions={hubOptions}
          vehicleTypeFilter={vehicleTypeFilter} setVehicleTypeFilter={setVehicleTypeFilter} vehicleTypeOptions={vehicleTypeOptions}
        />
      )}
      */}

    </div>
  )
}

export default SAMenu
